import { ChevronLeft, ChevronRight, X } from "lucide-react";
import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
// import "../Profile.css";

import LinkedAccountCardV1 from "./LinkedAccountCardV1";
import { courseCard1Object } from "./ExportLinkedAccount1Object";
import EditorCourseCard from "./EditorLinkedAccountCard";
import GoogleLocationForm from "./BusinessAddressLA";
import BusinessAddressLA from "./BusinessAddressLA";
import AddBankDetails from "./AddBankDetails";
import { createRazorpayLinkedAccTempEntry } from "../../../../store/actions/CreateApp/getAllBusinessTypes";
import DashboardCardRLA from "./ShowAccountDetails";

const LinkedAccountBuilder =({closePopUp})=>{
         const [courseThemeCard1Object, setCourseThemeCard1Object]=useState(courseCard1Object)
        const [currentBusinessType, setCurrentBusinessType]=useState({})
          const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
const [ showLeftQueBar, setShowLeftQueBar] = useState(true);

const [ statusVal, setStatusVal] = useState(false);
const [ nextStep, setNextStep] = useState("");

   const [animate, setAnimate] = useState(false);
   const [razorPayResp, setRazorPayResp] = useState({activation_status:""});
   
   const [razorPayRespStatus, setRazorPayRespStatus] = useState(false);
   const [razorPayRespTwo, setRazorPayRespTwo] = useState({});
     
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
  
       const [loader , setLoader] =useState({status:false});
 
      const steps = ([{number:1,name:"Business Type"},{number:2,name:"Bank Details  "},{number:3,name:"Class Address"},{number:4,name:"Finish"}]);
   
      const [activeStep , setActiveStep] =useState(1);
 
      
       
        const [fireConfetti, setFireConfetti] = useState(false);
       
        const [businessName, setBusinessName] = useState("");
        const [bankAccNumber, setBankAccountNo] = useState("");
        const [bankAccIFSC, setBankIFSC] = useState("");
        const [userName, setUserName] = useState("");
        const [panNo, setPanNo] = useState("");
        const [gstNo, setGstNo] = useState("");
        const [userEmail, setUserEmail] = useState("");
        
       const [itemArr, setItemArr] = useState([]);
       
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
         fireGetAccountDetails()
         fireGetAccountDetailsInfo()
        
        },[razorPayRespStatus])

        
        
             const fireGetAccountDetails=()=>{
              setLoader({status:true});
                  
                    const apiData = dispatch(createRazorpayLinkedAccTempEntry({userEmail:user_email,
                     
                      editType:"requestProductConf"
                      }));
                    /* get response as Promise   */
                    apiData.then(response => {
                      if(response){  
                      
                        if(response?.razorpay_response){
                           setRazorPayResp(response?.razorpay_response)
                      setResponseMessage(response?.message);
                      setSnackbarColor("rgba(144, 202, 249,1)");
                    
                  setLoader({status:false});
                     }else{
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                     
                     if(response?.logout){
                     
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  /* resetting Login input Fields */
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                     
                         
                    setLoader({status:false});
                    
                    setSnackbarVisible(true);
                    setTimeout(()=>{
                      
                      setSnackbarVisible(false);
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
            
               }

               
        
             const fireGetAccountDetailsInfo=()=>{
              setLoader({status:true});
                  
                    const apiData = dispatch(createRazorpayLinkedAccTempEntry({userEmail:user_email,
                     
                      editType:"fetchAndSyncLinkedAccount"
                      }));
                    /* get response as Promise   */
                    apiData.then(response => {
                      if(response){  
                      setRazorPayRespStatus(true)
                        if(response?.razorpay_response){
                         
                          setRazorPayRespTwo(response?.razorpay_response)
                      setResponseMessage(response?.message);
                      setSnackbarColor("rgba(144, 202, 249,1)");
                    
                  setLoader({status:false});
                     }else{
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                     
                     if(response?.logout){
                     
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  /* resetting Login input Fields */
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                     
                         
                    setLoader({status:false});
                    
                    setSnackbarVisible(true);
                    setTimeout(()=>{
                      
                      setSnackbarVisible(false);
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
            
               }
    return (<>
    <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{}} className="appDesignPopUpOpacity" style={{zIndex:"9999999",cursor:"pointer"}} > </div>
        <div   className="AreYouSurePopUp" style={{borderRadius: '20px',zIndex:"99999999",top:"0px",bottom:"0px",margin:"0px",padding:"0px"}}>
          <div onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
           borderRadius:"50%",float:"right",margin:"10px",
         background:"#958FDA",zIndex:999999}} onClick={()=>closePopUp(false)}   >
           <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 


   
    <div style={{padding:"5px",display:"flex",justifyContent:"center",margin:"0px",padding:"0px"}}><h2 style={{fontFamily:courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily }}>{razorPayResp?.activation_status=="activated"?"Your Account Is Active Now!!!":"Create linked Razorpay Account"}</h2></div>
   {razorPayRespStatus&&razorPayResp?<>
   
   {razorPayResp?.activation_status=="activated"?"":<div   className=" progress-bar-container "style={{position:"relative",zIndex:"99",padding:"15px",marginTop:"-30px"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclekRazorpayLA"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){ setActiveStep(1) ;setNextStep("");
          }else if(step?.number==2){ setActiveStep(2) ;setNextStep("addBankDetails");
          }else if(step?.number==3){setActiveStep(3) ;setNextStep("addAddress");
          }else if(step?.number==4){setActiveStep(4) ;setNextStep("Finish");
          }
        }} style={{position:"relative",cursor:"pointer"}} key={step?.number}>
          <div
            
            className={`circlekRazorpayLA ${step?.number <= activeStep ? "activekRazorpayLA" : ""}` }
            style={{zIndex:"99",background: `${step?.number ===1?
              `conic-gradient(rgba(144, 202, 249,1) 0% 50%, rgba(144, 202, 249,1)
                                                100% 100%)`:""}
            `}} 
          ><div   className={`circlekInnRazorpayLA `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",zIndex:"9",height:"5px",border:"2px solid rgba(144, 202, 249,1)",background:"#ffffff",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>}  <div className="scrollerRazorpayLA"  style={{overflowY:"auto",margin:"0px",padding:"0px"}}>
     
     {/* <LeadInfoCardTheme1 status={statusVal} setStatus={(val)=>{val?setStatusVal(true):setStatusVal(false)}} courseCard1Object = {courseThemeCard1Object} /> */}
     
     {razorPayResp?.activation_status=="activated"?<DashboardCardRLA data={razorPayRespTwo} data2 ={razorPayResp}/>:nextStep=="addBankDetails"?<AddBankDetails setNextStep={(val,no)=>{setNextStep(val);setActiveStep(no) ;}} currentBusinessTypeVal={currentBusinessType}/>:nextStep=="addAddress"?<BusinessAddressLA setNextStep={(val,no)=>{setNextStep(val);setActiveStep(no) ;}} />:nextStep=="Finish"?<DashboardCardRLA data={razorPayRespTwo} data2 ={razorPayResp}/>:<LinkedAccountCardV1 onSendBack={(obj)=>{setCurrentBusinessType(obj);setNextStep("addBankDetails");;setActiveStep(2) ;}} courseThemeCard1Object={courseThemeCard1Object} course ={{}} />
    }
      
      </div>
   </>:""}
   
   </div> 


     <style>{ `
   
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
}
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
}
/* xs */
@media (max-width: 767px) {
  
}
        `}
        </style>
    </>) 
}

export default LinkedAccountBuilder;